<template>
    <div>
      <div class="button-wrapper">
        <router-link to="/emotions"><v-btn class="choice">みんなの投稿</v-btn></router-link>
        <router-link to="/form"><v-btn class="choice">大事なものを投稿する</v-btn></router-link>
      </div>

<!--  <Emotions/>
      <Postform/> router使わず、こんな風に直書きもできる。-->
      <router-view/>
    </div>
    
</template>

<script>
  //import Emotions from './components/Emotions'
  //import Postform from './components/Form'


  export default {
    name: 'App',
  //  components: {
  //    Emotions,
  //    Postform
  //  },
  }
</script>

<style>
@import "css/style.css";
@import "css/normalize.css";
</style>